import { render, staticRenderFns } from "./AddPermissionModal.vue?vue&type=template&id=4b7448b6&"
import script from "./AddPermissionModal.vue?vue&type=script&lang=js&"
export * from "./AddPermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports